export const kraftOneFace = 'Kraft';
export const whiteOneFace = 'Blanco una cara';
export const whiteTwoFaces = 'Blanco dos caras';
export const NOT_CLIENT_ID = -100;
